import { getItem } from 'owa-local-storage';
import ProjectInLocalStorage, { OUTLOOK_SPACES_LOCAL_STORAGE_KEY } from './ProjectInLocalStorage';

export default function getProjectsInLocalStorage() {
    let projectsInLocalStorage: { [key: string]: ProjectInLocalStorage } = {};

    try {
        projectsInLocalStorage = JSON.parse(
            getItem(window, OUTLOOK_SPACES_LOCAL_STORAGE_KEY) || '{}'
        );
    } catch {}

    return projectsInLocalStorage;
}
